import {
  GET_DYNAMIC_LIST,
  GET_DYNAMIC_LIST_SUCCESS,
  GET_DYNAMIC_LIST_FAIL,
  GET_DYNAMIC_DATA,
  GET_DYNAMIC_DATA_SUCCESS,
  ADD_NEW_DYNAMIC_DATA,
  ADD_DYNAMIC_DATA_SUCCESS,
  UPDATE_DYNAMIC_DATA,
  UPDATE_DYNAMIC_DATA_SUCCESS,
  DELETE_DYNAMIC_DATA,
  DELETE_DYNAMIC_DATA_SUCCESS,
  DYNAMIC_DATA_API_ERROR
} from "./actionTypes"

export const getDynamicList = (guid) => ({
  type: GET_DYNAMIC_LIST,
  payload:guid
})

export const getDynamicListSuccess = (actionType, data) => ({
  type: GET_DYNAMIC_LIST_SUCCESS,
  payload: { actionType, data },
});

export const getDynamicListFail = (actionType, error) => ({
  type: GET_DYNAMIC_LIST_FAIL,
  payload: { actionType, error },
});


export const getDynamicData = url => ({
  type: GET_DYNAMIC_DATA,
  payload: url,
})

export const getDynamicDataSuccess = dynamicData => ({
  type: GET_DYNAMIC_DATA_SUCCESS,
  payload: dynamicData,
})

export const addNewDynamicData = (url, dynamicData) => ({
  type: ADD_NEW_DYNAMIC_DATA,
  url: url,
  payload: dynamicData,
})

export const addDynamicDataSuccess = dynamicData => ({
  type: ADD_DYNAMIC_DATA_SUCCESS,
  payload: dynamicData,
})

export const updateDynamicData = (url, dynamicData) => ({
  type: UPDATE_DYNAMIC_DATA,
  url: url,
  payload: dynamicData,
})

export const updateDynamicDataSuccess = dynamicData => ({
  type: UPDATE_DYNAMIC_DATA_SUCCESS,
  payload: dynamicData,
})

export const deleteDynamicData = (url,guid) => ({
  type: DELETE_DYNAMIC_DATA,
  url: url,
  payload: guid,
})

export const deleteDynamicDataSuccess = guid => ({
  type: DELETE_DYNAMIC_DATA_SUCCESS,
  payload: guid,
})

export const dynamicDataApiError = error => ({
  type: DYNAMIC_DATA_API_ERROR,
  payload: error,
})